var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuConversions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.014,
    height: 19.266,
    viewBox: "0 0 14.014 19.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(-69.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M75.1,245.314v4.922l3.387-1.508v-3.413L83.8,240H69.789Z",
    transform: "translate(0 -230.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M241.564,2.822a.564.564,0,0,0,0,1.129,1.689,1.689,0,0,1,.564,3.283V7.9h2.42a4.541,4.541,0,0,0-2.42-7.9V1.8a1.691,1.691,0,0,1,1.129,1.589h-1.129A.565.565,0,0,0,241.564,2.822Z",
    transform: "translate(-164.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M136,4.516A4.551,4.551,0,0,0,137.531,7.9h2.42V7.234a1.691,1.691,0,0,1-1.129-1.589h1.129a.564.564,0,1,0,.564-.564,1.689,1.689,0,0,1-.564-3.283V0A4.558,4.558,0,0,0,136,4.516Z",
    transform: "translate(-63.72)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuConversions);
export default __webpack_public_path__ + "static/media/icon-menu-conversions.86827f67c2f59b24f378fb8183cbf08e.svg";
export { ForwardRef as ReactComponent };